<avs-li-location-options
  type="room"
  (changed)="patchLocationForm($event)"
  [config]="locationConfig()"
/>

@if (form.value?.roomId) {
  <div class="flex flex-row">
    <label class="input-main-label capitalize">
      Camera *
    </label>

    <avs-li-device-selector
      class="flex-1"
      (changed)="patchForm({
        devices: { camera: $event },
        datapoints: {}
      })"
      [filters]="{
        space : form.value?.roomId
      }"
      [value]="form.value.devices?.camera"
    />
  </div>

  <div class="flex flex-row">
    <label class="input-main-label capitalize">
      Air quality monitor *
    </label>

    <avs-li-device-selector
      class="flex-1"
      (changed)="patchForm({
        devices: { airMonitor: $event },
        datapoints: {}
      })"
      [filters]="{
        space : form.value?.roomId
      }"
      [value]="form.value.devices?.airMonitor"
    />
  </div>
}

@if (form.value.devices?.camera && form.value.devices?.airMonitor) {
  <div class="flex flex-row">
    <label class="input-main-label capitalize">
      People *
    </label>
    <avs-li-data-point-selector
      class="flex-1"
      (changed)="patchForm({
        datapoints: { people: $event }
      })"
      [deviceId]="form.value.devices?.camera"
      [locationId]="form.value?.locationId"
      [value]="form.value?.datapoints?.people"
    />
  </div>

  <div class="flex flex-row">
    <label class="input-main-label capitalize">
      Temperature *
    </label>
    <avs-li-data-point-selector
      class="flex-1"
      (changed)="patchForm({
        datapoints: { temperature: $event }
      })"
      [deviceId]="form.value.devices?.airMonitor"
      [locationId]="form.value?.locationId"
      [value]="form.value?.datapoints?.temperature"
    />
  </div>

  <div class="flex flex-row">
    <label class="input-main-label capitalize">
      Humidity *
    </label>
    <avs-li-data-point-selector
      class="flex-1"
      (changed)="patchForm({
        datapoints: { humidity: $event }
      })"
      [deviceId]="form.value.devices?.airMonitor"
      [locationId]="form.value?.locationId"
      [value]="form.value?.datapoints?.humidity"
    />
  </div>

  <div class="flex flex-row">
    <label class="input-main-label capitalize">
      CO2 *
    </label>
    <avs-li-data-point-selector
      class="flex-1"
      (changed)="patchForm({
        datapoints: { co2: $event }
      })"
      [deviceId]="form.value.devices?.airMonitor"
      [locationId]="form.value?.locationId"
      [value]="form.value?.datapoints?.co2"
    />
  </div>

  <div class="flex flex-row">
    <label class="input-main-label capitalize">
      PM2.5 *
    </label>
    <avs-li-data-point-selector
      class="flex-1"
      (changed)="patchForm({
        datapoints: { pm25: $event }
      })"
      [deviceId]="form.value.devices?.airMonitor"
      [locationId]="form.value?.locationId"
      [value]="form.value?.datapoints?.pm25"
    />
  </div>

  <div class="flex flex-row">
    <label class="input-main-label capitalize">
      PM10 *
    </label>
    <avs-li-data-point-selector
      class="flex-1"
      (changed)="patchForm({
        datapoints: { pm10: $event }
      })"
      [deviceId]="form.value.devices?.airMonitor"
      [locationId]="form.value?.locationId"
      [value]="form.value?.datapoints?.pm10"
    />
  </div>

  <div class="flex flex-row">
    <label class="input-main-label capitalize">
      TVOC *
    </label>
    <avs-li-data-point-selector
      class="flex-1"
      (changed)="patchForm({
        datapoints: { tvoc: $event }
      })"
      [deviceId]="form.value.devices?.airMonitor"
      [locationId]="form.value?.locationId"
      [value]="form.value?.datapoints?.tvoc"
    />
  </div>
}
